import { render } from "./MPagination.vue?vue&type=template&id=315cd19e&scoped=true"
import script from "./MPagination.vue?vue&type=script&lang=js"
export * from "./MPagination.vue?vue&type=script&lang=js"

import "./MPagination.vue?vue&type=style&index=0&id=315cd19e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-315cd19e"]])

export default __exports__